export default __webpack_public_path__ + "static/media/Ellipse.889ac35a.svg";